// Generación de Vouchers (por reserva) y Travel Document (viaje completo) — 2.7.
// Construye HTML imprimible y lo abre en una ventana nueva con print() automático.
// (PDF = imprimir a PDF desde el navegador. El compartir por magic-link llega más adelante.)

import { RESERVA_TYPE_LABELS, RESERVA_STATUS_LABELS, fmtDate } from "@/pages/trips/shared";

const esc = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const BRAND = "#0e7490"; // Océano

const baseCss = `
  * { box-sizing: border-box; }
  body { font-family: 'Segoe UI', system-ui, -apple-system, sans-serif; color:#0f172a; margin:0; padding:32px; }
  .wrap { max-width: 820px; margin: 0 auto; }
  .brand { display:flex; align-items:center; justify-content:space-between; border-bottom:3px solid ${BRAND}; padding-bottom:12px; margin-bottom:20px; }
  .brand h1 { color:${BRAND}; font-size:22px; margin:0; letter-spacing:.5px; }
  .brand .sub { color:#64748b; font-size:12px; }
  h2 { font-size:15px; color:${BRAND}; margin:22px 0 8px; text-transform:uppercase; letter-spacing:.6px; }
  table { width:100%; border-collapse:collapse; margin:6px 0 14px; }
  th, td { text-align:left; padding:7px 9px; font-size:13px; border-bottom:1px solid #e2e8f0; vertical-align:top; }
  th { background:#f1f5f9; color:#334155; font-size:11px; text-transform:uppercase; letter-spacing:.4px; }
  .meta { display:grid; grid-template-columns:1fr 1fr; gap:6px 24px; font-size:13px; }
  .meta div b { color:#475569; font-weight:600; }
  .badge { display:inline-block; padding:2px 8px; border-radius:999px; font-size:11px; font-weight:600; }
  .ok { background:#d1fae5; color:#065f46; }
  .pend { background:#fef3c7; color:#92400e; }
  .card { border:1px solid #e2e8f0; border-radius:10px; padding:16px 18px; margin-bottom:12px; }
  .day { color:${BRAND}; font-weight:700; font-size:13px; }
  .foot { margin-top:28px; border-top:1px solid #e2e8f0; padding-top:10px; color:#94a3b8; font-size:11px; }
  @media print { body { padding:0; } .noprint { display:none; } }
`;

const shell = (title, inner) => `<!doctype html><html lang="es"><head><meta charset="utf-8">
<title>${esc(title)}</title><style>${baseCss}</style></head>
<body><div class="wrap">
  <div class="brand"><div><h1>Viaja de Verdad</h1><div class="sub">SOFI 2.0 · ${esc(title)}</div></div>
  <div class="sub">${new Date().toLocaleDateString("es-ES")}</div></div>
  ${inner}
  <div class="foot">Documento generado por SOFI 2.0 · Viaja de Verdad / Espíritu Travel. No es una factura.</div>
</div>
<script>window.onload=function(){setTimeout(function(){window.print();},250);};</script>
</body></html>`;

const open = (html) => {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  w.focus();
  return true;
};

export function openVoucher(trip, reserva) {
  const confirmed = reserva.status_reserva === "confirmacion";
  const inner = `
    <h2>Voucher de servicio</h2>
    <div class="meta">
      <div><b>Cliente:</b> ${esc(trip.main_traveler)}</div>
      <div><b>Estado:</b> <span class="badge ${confirmed ? "ok" : "pend"}">${esc(RESERVA_STATUS_LABELS[reserva.status_reserva] || reserva.status_reserva)}</span></div>
      <div><b>Servicio:</b> ${esc(reserva.service)}</div>
      <div><b>Tipo:</b> ${esc(RESERVA_TYPE_LABELS[reserva.type] || reserva.type)}</div>
      <div><b>Proveedor:</b> ${esc(reserva.provider_name || "—")}</div>
      <div><b>Ciudad:</b> ${esc(reserva.city || "—")}${reserva.country ? " (" + esc(reserva.country) + ")" : ""}</div>
      <div><b>Entrada:</b> ${esc(fmtDate(reserva.date_entry))}${reserva.hour_entry ? " · " + esc(reserva.hour_entry) : ""}</div>
      <div><b>Salida:</b> ${esc(fmtDate(reserva.date_exit))}</div>
      <div><b>Pax:</b> ${esc(reserva.quantity || 1)}${reserva.number_of_children ? " + " + esc(reserva.number_of_children) + " niños" : ""}</div>
      <div><b>Habitación:</b> ${esc(reserva.room || "—")}</div>
    </div>
    ${reserva.note ? `<h2>Notas / detalle operativo</h2><div class="card">${esc(reserva.note)}</div>` : ""}
  `;
  return open(shell(`Voucher · ${trip.main_traveler}`, inner));
}
